exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);

// module
exports.push([module.id, ".hero{height:30rem;padding:3rem;background:url(" + require("../../img/iphone-home@2x.png") + ") no-repeat;background-position-y:25%;background-position-x:center;background-size:85%}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/common/client/app/common/hero/hero.scss"],"names":[],"mappings":"AAGA,MACE,aACA,aAEA,mDACA,0BACA,6BACA,mBAAoB,CACrB","file":"hero.scss","sourcesContent":["@import '../common';\n@import '../../bootstrap-customizations';\n\n.hero {\n  height: 30rem;\n  padding: 3rem;\n\n  background: url(../../img/iphone-home@2x.png) no-repeat;\n  background-position-y: 25%;\n  background-position-x: center;\n  background-size: 85%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./client/app/common/hero/hero.scss
// module id = 371
// module chunks = 0